var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-658 -798.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(2 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chevron-thin-right",
    "data-name": "Icon metro-chevron-thin-right",
    d: "M4.381,5.133.12.705a.416.416,0,0,1,0-.584A.406.406,0,0,1,.7.121L5.371,4.84a.416.416,0,0,1,0,.584L.7,10.143a.406.406,0,0,1-.578,0,.416.416,0,0,1,0-.584L4.381,5.133Z",
    transform: "translate(671.264 805.729) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y1: 8.166,
    transform: "translate(666.127 802.148)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_93",
    "data-name": "Path 93",
    transform: "translate(658 798.648)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 1 C 5.037380218505859 1 1 5.037380218505859 1 10 C 1 14.96261978149414 5.037380218505859 19 10 19 C 14.96261978149414 19 19 14.96261978149414 19 10 C 19 5.037380218505859 14.96261978149414 1 10 1 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrow-down-circle.ba941a82fa0c4110516825eea3c734ca.svg";
export { ForwardRef as ReactComponent };